import ActionType from './action-type'
import * as Actions from './actions'
import {type ThunkAction} from 'redux-thunk'
import {Api, type QuerySpecification} from '../../../api/Api'
import {locationTagThreatScore, type QueryCancellation} from '../../../websocket/Queries'
import {type AppState} from '../../types/app-state'
import {TimeRange} from '../../../values/TimeRange'
import {type GuidType} from '../../../values/generic-type-definitions'
import {type LocationTagScore} from '../../../values/location-tag-score'

const QUERY_PATH = 'locationTagThreatScore'
const QUERY_SCHEDULE = '10s'

function etsQueryLocationTag(timeRange: TimeRange, locationTag: string): QuerySpecification {
    return {
        path: QUERY_PATH,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        localId: `${locationTagThreatScore}-${timeRange}-${locationTag}`,
        schedule: QUERY_SCHEDULE,
        params: {
            identity: locationTag,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            fromRelative: `now() - ${timeRange}`,
        },
    }
}

export function fetchLocationTagThreatScore(
    timeRange: TimeRange,
    locationTag: GuidType,
): ThunkAction<QueryCancellation, AppState, Api, Actions.Action> {
    return (dispatch, _, api) => {
        dispatch(requestLocationTagThreatScore(timeRange))

        const query: QuerySpecification = etsQueryLocationTag(timeRange, locationTag)

        api.newQuery(query, (data) => {
            const scores: LocationTagScore[] = convertScores(data as RawEtsList)
            dispatch(receiveLocationTagThreatScore(timeRange, scores))
        })

        return () => {
            api.cancelQuery({localId: query.localId})
        }
    }
}

export function requestLocationTagThreatScore(
    timeRange: TimeRange,
): Actions.RequestLocationTagThreatScore {
    return {
        type: ActionType.REQUEST_LOCATION_TAG_THREAT_SCORE,
        payload: timeRange,
    }
}

/**
 * CDS-6008. Clears the loading flag for one range without touching its trend,
 * so a failed fetch stops the graph spinning and leaves whatever was last
 * received on screen.
 */
export function locationTagThreatScoreRequestFailed(
    timeRange: TimeRange,
): Actions.LocationTagThreatScoreRequestFailed {
    return {
        type: ActionType.LOCATION_TAG_THREAT_SCORE_REQUEST_FAILED,
        payload: timeRange,
    }
}

export function receiveLocationTagThreatScore(
    timeRange: TimeRange,
    scores: LocationTagScore[],
): Actions.ReceiveLocationTagThreatScore {
    return {
        type: ActionType.RECEIVE_LOCATION_TAG_THREAT_SCORE,
        payload: {
            timeRange: timeRange,
            scores: scores,
        },
    }
}

export interface RawEts {
    timestamp: number
    score: number
}

interface RawEtsList {
    items: RawEts[]
}

function convertScores(data: RawEtsList): LocationTagScore[] {
    const scores: RawEts[] = data.items
    return scores.map((value) => {
        return {
            time: value.timestamp,
            tagScore: value.score,
        }
    })
}
